import { useEffect, type KeyboardEvent, type ReactNode } from "react";

// Utilitários de UI das telas de estoque/PCF (22/10/2026): formato pt-BR, campos numéricos travados e Enter = Tab.

const fmt = (c: number) => new Intl.NumberFormat("pt-BR", { minimumFractionDigits: c, maximumFractionDigits: c });
export const fN = (v: number, c = 2) => fmt(c).format(Number(v) || 0);

/** Só dígitos e UMA vírgula (ponto do teclado numérico vira vírgula); `casas` limita os decimais (0 = inteiro). */
export function soNum(v: string, casas: number): string {
  if (!casas) return v.replace(/\D/g, "");
  let s = (v.includes(",") ? v.replace(/\./g, "") : v.replace(/\./g, ",")).replace(/[^0-9,]/g, "");
  const i = s.indexOf(",");
  if (i >= 0) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/,/g, "").slice(0, casas);
  return s;
}
export const parseBR = (s: string) => Number(String(s ?? "").replace(/\./g, "").replace(",", ".")) || 0;
/** número -> texto do input (sem milhar, vírgula) */
export const paraInput = (v: number, casas: number) => (Number(v) ? fN(v, casas).replace(/\./g, "") : "");

/** Enter = Tab dentro de um container (em botões o Enter mantém a função). */
export function enterTab(e: KeyboardEvent, raiz: HTMLElement | null) {
  if (e.key !== "Enter" || (e.target as HTMLElement).tagName === "BUTTON" || (e.target as HTMLElement).tagName === "TEXTAREA") return;
  e.preventDefault();
  const foc = Array.from(raiz?.querySelectorAll<HTMLElement>("input,select,textarea,button") ?? []).filter(
    (x) => !(x as HTMLInputElement).disabled && x.tabIndex !== -1 && x.offsetParent !== null && !(x as HTMLInputElement).readOnly
  );
  const i = foc.indexOf(e.target as HTMLElement);
  if (i >= 0 && i < foc.length - 1) foc[i + 1]?.focus();
}

/** Modal padrão do painel (tamanho fixo) com Esc fechando. */
export function Modal({ titulo, sub, largura = 980, onClose, children }: { titulo: string; sub?: string; largura?: number; onClose: () => void; children: ReactNode }) {
  useEffect(() => {
    const k = (e: globalThis.KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [onClose]);
  return (
    <div className="modal-backdrop">
      <div className="modal-panel" style={{ width: `min(${largura}px, 96vw)` }} onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <div>
            {sub && <div className="modal-eyebrow">{sub}</div>}
            <h2 style={{ margin: 0, fontSize: 18 }}>{titulo}</h2>
          </div>
          <button className="btn-secundario" onClick={onClose} title="Voltar (Esc)">
            Voltar
          </button>
        </header>
        <div style={{ padding: "16px 22px 20px" }}>{children}</div>
      </div>
    </div>
  );
}

/** Confirmação Sim/Não em modal (foco no Não). */
export function Confirma({ texto, onSim, onNao }: { texto: string | null; onSim: () => void; onNao: () => void }) {
  if (!texto) return null;
  return (
    <div className="modal-backdrop" style={{ zIndex: 120 }}>
      <div className="modal-panel" style={{ width: "min(460px, 94vw)", padding: 20 }}>
        <p style={{ margin: "0 0 16px", fontSize: 15, whiteSpace: "pre-wrap" }}>{texto}</p>
        <div className="pcf-acoes">
          <span className="spacer" />
          <button className="btn-acao" onClick={onSim}>
            Sim
          </button>
          <button className="btn-secundario" autoFocus onClick={onNao}>
            Não
          </button>
        </div>
      </div>
    </div>
  );
}
